export default __webpack_public_path__ + "1ab39ba30171cdf7bf2bed546c50ecfd.svg";